<template>
    <a class="btn-annotation btn-toggle-hanpin"
       href="#"
       :id="`btn-toggle-${annot.id}`"
       :style="data.styleRect"
       @click.prevent="toggleHanPin"
       :class="data.classRect"
    >
        <img :src="`${bookInfoState.publicPath}/${props.annot.iconSrc}`"
             v-if="props.annot.iconSrc"
        >
    </a>
</template>

<script>
    import {ref, reactive, onMounted, onUpdated, watchEffect, watch, computed}  from "vue";
    import {useParser} from "@/modules/reader/annotations/parser";
    import {useBookInfo} from "@/modules/reader/book/bookinfo";
    import {usePageResize} from "@/modules/reader/book/pageResize";
    import {useAnnotationHelper} from "@/modules/reader/annotations/annotationHelper";
    import {useKaraokeControl} from "@/modules/reader/karaoke/karaokeControl";
    import {usePlayBlockControl} from "@/modules/reader/karaoke/playBlockControl";
    import cssvar from '@/scss/_variables.scss';
    import {useTool} from "@/modules/reader/tools/tools"

    const colorRect = cssvar.colorRect;
    const {getResizedAnnotationPos, styleAnnotationBtn} = useAnnotationHelper();
    const {karaokeState} = useKaraokeControl();
    const {playBlockState} = usePlayBlockControl();

    export default {

        props: {
          annot:Object,
          pagenum:Number
        },
        setup(props, context) {

            const { parserState, readData} = useParser();
            const { bookInfoState} = useBookInfo();
            const { pageResizeState} = usePageResize();
            const {toolState} = useTool();


            const data = reactive({
                styleRect:computed(()=>{
                    let domPos = props.annot.domPos;
                    return {
                        ...getResizedAnnotationPos(domPos),
                        ...styleAnnotationBtn(props.annot.hide)
                    }
                }),
                classRect: computed(()=>{
                    //TODO: see if it's possible to wrap in a common method...
                    return {
                        disabled: (playBlockState.id || playBlockState.spanSrc || karaokeState.activeAudioSrc)
                    }
                })
            });

            const toggleHanPin =()=>{

                if (props.annot.isToggleHan) {
                    if (bookInfoState.localHanVisible[props.pagenum][`rect_${props.annot.id}`] === undefined) {
                        bookInfoState.localHanVisible[props.pagenum][`rect_${props.annot.id}`] = !bookInfoState.globalHanVisible;
                    } else {
                        bookInfoState.localHanVisible[props.pagenum][`rect_${props.annot.id}`] = !bookInfoState.localHanVisible[props.pagenum][`rect_${props.annot.id}`];
                    }
                } else if (props.annot.isTogglePinYin) {
                    if (bookInfoState.localPinYinVisible[props.pagenum][`rect_${props.annot.id}`] === undefined) {
                        bookInfoState.localPinYinVisible[props.pagenum][`rect_${props.annot.id}`] = !bookInfoState.globalPinYinVisible;
                    } else {
                        bookInfoState.localPinYinVisible[props.pagenum][`rect_${props.annot.id}`] = !bookInfoState.localPinYinVisible[props.pagenum][`rect_${props.annot.id}`];
                    }
                }
            }

            onMounted(() => {

            });

            return {
                props,
                data,
                pageResizeState,
                bookInfoState,
                parserState,
                toggleHanPin,
                getResizedAnnotationPos
            }

        }
    }

 </script>


<style scoped lang="scss">


</style>